import { districtRoutes, getBaseURL } from '../../../common/routes';
import { withoutCommunityPath } from '../../../common/community-path';
// Absolute rather than relative: staff on the root host manage tours belonging to communities whose
// public page only exists on their own subdomain.
const publicTourURL = (tour) => getBaseURL(tour.communitySubdomain) + withoutCommunityPath(districtRoutes.toursDetail.getURL({ id: tour.id }));
// Where the listing and the wizard send someone to see a tour's public page, and what to call it.
// An unpublished tour opens the same page behind ?preview, which the page serves to whoever may
// manage it. Unsaved edits are on neither, so this follows the saved status. None when the owning
// community has no subdomain, because then it has no public site to open.
export const viewAction = (tour) => tour.communitySubdomain === ''
    ? null
    : tour.status === 'active'
        ? { 'href': publicTourURL(tour), 'label': 'View tour page', 'icon': 'bi-box-arrow-up-right' }
        : { 'href': `${publicTourURL(tour)}?preview`, 'label': 'Preview tour page', 'icon': 'bi-eye' };
